import { EcomPlatformViewerScriptContext } from '../../../viewer-script/types';
import { ExpressCheckoutService } from './services/ExpressCheckoutService';
import { ExpressCheckoutSettingsService } from './services/ExpressCheckoutSettingsService';
import type {
  ShippingContactRestricted,
  ShippingMethod,
} from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import type { PaymentAuthorizedArgs } from '@wix/cashier-express-checkout-widget/dist/src/types/ExternalContract';
import type { ExpressCheckoutButtonsState } from './types';

export function createExpressCheckoutPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  return {
    settings: () =>
      ExpressCheckoutSettingsService.fromContext(context).getSettings(),
    onStateChange: (params: {
      state: ExpressCheckoutButtonsState;
      numberOfButtons?: number;
      origin?: string;
    }) => ExpressCheckoutService.getInstance(context).onStateChange(params),
    getButtonsData: (callerContext: { widgetId: string }) =>
      ExpressCheckoutService.getInstance(context).getButtonsData(callerContext),
    onCancel: () => ExpressCheckoutService.getInstance(context).onCancel(),
    getInitialPaymentData: (checkoutId: string, paymentMethodTypeId?: string) =>
      ExpressCheckoutService.getInstance(context).getInitialPaymentData(
        checkoutId,
        paymentMethodTypeId,
      ),
    onShippingContactSelected: (shippingContact: ShippingContactRestricted) =>
      ExpressCheckoutService.getInstance(context).onShippingContactSelected(
        shippingContact,
      ),
    onShippingMethodSelected: (shippingMethod: ShippingMethod) =>
      ExpressCheckoutService.getInstance(context).onShippingMethodSelected(
        shippingMethod,
      ),
    onPaymentAuthorized: (
      payment: PaymentAuthorizedArgs,
      shouldUpdateShippingAddress: boolean,
      callerContext: {
        contentAppId?: string;
        contentComponentId?: string;
        successUrl?: string;
        continueShoppingUrl?: string;
        widgetId: string;
      },
    ) =>
      ExpressCheckoutService.getInstance(context).onPaymentAuthorized(
        payment,
        shouldUpdateShippingAddress,
        callerContext,
      ),
  };
}
